import type { Country } from "../Country.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";

export function shouldApplyTariffs(destinationCountry: Country | "outsideEu"): boolean {
	return !isCountryInEuropeanUnion(destinationCountry);
}
